import React, { useState } from "react";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import HttpsIcon from "@mui/icons-material/Https";
import { Link } from "react-router-dom";
import logoImage from "../../assests/images/logo.png";
import { authServices } from "../../services/authServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import CountDown from "../common/countDown";
import { validationServices } from "../../services/validationServices";

function MobileLogin() {
  let [text, setText] = useState("");
  let [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isCountDownStart, setIsCountDownStart] = useState(false);
  const [sendOtpObj, setSendOtpObj] = useState({});
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [showOTPComponent, setShowOTPComponent] = useState(false);

  const onTextChange = (e) => {
    setText(e.target.value);
  };
  const onOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const countDownClose = (event, reason) => {
    setIsCountDownStart(false);
  };

  const onGetOtp = (e) => {
    let validationRes = validationServices.validatePhoneNumber(text);
    if (!validationRes) {
      openAlert(true, "error", `Please enter valid phone number.`);
      return;
    }
    setIsLoading(true);
    let obj = {
      resend: false,
      national: "+91",
      phoneNumber: text,
      orderId: "",
    };
    authServices
      .sendOtpAuth(obj)
      .then(function (response) {
        if (response?.data?.success == true) {
          setSendOtpObj(response?.data?.data);
          openAlert(true, "success", response?.data?.message);
          setIsCountDownStart(true);
          setShowOTPComponent(true);
        }
      })
      .catch(function (error) {
        setSendOtpObj({});
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const verifyOtp = (e) => {
    setIsLoading(true);
    let obj = {
      type: "mobile",
      national: "+91",
      userInfo: text,
      password: sendOtpObj?.orderId,
      otp: otp,
      // "resend": false,
    };
    authServices
      .loginAuth(obj)
      .then(function (response) {
        if (response?.data?.success == true) {
          openAlert(true, "success", response?.data?.message);
          sessionStorage.setItem("user", JSON.stringify(response?.data?.data));
          if (response?.data?.data?.role.name == "VENDOR") {
            window.location.href = "/admin/welcome";
          } else {
            window.location.href = "/admin/dashboard";
          }
          // window.location.href= '/admin/dashboard';
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  return (
    <div className="App">
      <div class="login-form">
        <div class="text-center">
          <div className="logo_login_react_vendors">
            <img src={logoImage} alt="" height="51" />
          </div>
          <h3 class="title">Login to your Account</h3>
          <p>See what is going on with your business</p>
        </div>
        <div>
          <div class="mb-4 position-relative">
            <label class="mb-1 text-dark">Mobile Number</label>
            <input
              type="tel"
              class="form-control form-h"
              placeholder="Enter your mobile number"
              onChange={onTextChange}
              value={text}
            />

            <span class="user">
              <PhoneIphoneIcon />
            </span>
          </div>

          {!isCountDownStart && showOTPComponent === false && (
            <div className="main_otp_react_listing">
              <button
                // style="color: #fff; text-decoration: none"
                class="btn btn-primary btn-log mb-4"
                onClick={onGetOtp}
              >
                Get OTP
              </button>
              {/* <p onClick={onGetOtp}>  </p> */}
            </div>
          )}
          {isCountDownStart && (
            <p className="main_otp_react_listing">
              <CountDown
                isCountDownStart={isCountDownStart}
                countDownClose={countDownClose}
              />
            </p>
          )}

          {showOTPComponent ? (
            <div>
              <div class="mb-4 position-relative">
                <label class="mb-1 text-dark">OTP</label>
                <input
                  type="text"
                  class="form-control form-h"
                  placeholder="Enter the OTP"
                  onChange={onOtpChange}
                  value={otp}
                />

                <span class="user">
                  <HttpsIcon />
                </span>
              </div>

              <div class="text-center mb-4">
                <button
                  // style="color: #fff; text-decoration: none"
                  class="btn btn-primary btn-log"
                  onClick={verifyOtp}
                >
                  Submit OTP
                </button>
              </div>
            </div>
          ) : null}
        </div>

        <h6 class="login-title">
          <span> OR </span>
        </h6>
        <div class="mb-3 d-flex">
          <Link to="/auth/login" className="btn otp flex-fill">
            Login with Username{" "}
          </Link>
          <Link to="/auth/email-login" className="btn otp flex-fill">
            Login with Email{" "}
          </Link>
        </div>
      </div>

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default MobileLogin;
